import React, { useState } from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import { 
  FaCalendarAlt, 
  FaUsers, 
  FaBook, 
  FaCross, 
  FaHandshake,
  FaChevronDown,
  FaChevronUp,
  FaFileAlt,
  FaCheckCircle,
  FaLightbulb
} from 'react-icons/fa';
import './AgendaPastoral.css';

const AgendaPastoral = () => {
  // Todas las secciones abiertas por defecto
  const [expandedSections, setExpandedSections] = useState({
    institucional: true,
    objetivo: true,
    consejo: true,
    accion: true,
    visitas: true,
    notas: true
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="agenda-pastoral-page">
      <Breadcrumbs />
      <section className="section">
        <div className="container">
          <div className="agenda-pastoral-header">
            <h1 className="page-title">Agenda Pastoral 2026</h1>
            <p className="page-subtitle">Diócesis de Ipiales - En Comunión, Participación y Misión</p>
            <div className="agenda-lema">
              <FaBook className="lema-icon" />
              <p className="lema-text">"Si nuestra fe confirmamos, en la liturgia con Jesús nos encontramos"</p>
            </div>
          </div>

          <div className="agenda-pastoral-content">
            {/* Información Institucional */}
            <section className="agenda-section info-institucional-section">
              <div className="section-header" onClick={() => toggleSection('institucional')}>
                <h2><FaFileAlt /> Información Institucional</h2>
                {expandedSections.institucional ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {expandedSections.institucional && (
                <div className="section-content">
                  <div className="info-institucional-box">
                    <h3>Datos de la Diócesis</h3>
                    <div className="info-simple">
                      <p><strong>Diócesis de Ipiales</strong></p>
                      <p><strong>NIT:</strong> 891200935-2</p>
                      <p><strong>Lema:</strong> "En Comunión, Participación y Misión"</p>
                    </div>
                  </div>
                  
                  <div className="info-parroquial-box">
                    <h3>Información Parroquial</h3>
                    <p className="info-note">Esta sección es para que cada parroquia complete sus datos al recibir la agenda física.</p>
                    <div className="info-simple">
                      <p><strong>Parroquia:</strong> _______________________________</p>
                      <p><strong>NIT de la Parroquia:</strong> _______________________________</p>
                      <p><strong>Dirección:</strong> _______________________________</p>
                      <p><strong>Centro Pastoral, Comisión Diocesana o estructura pastoral:</strong> _______________________________</p>
                    </div>
                  </div>
                  
                  <div className="info-personal-box">
                    <h3>Información Personal</h3>
                    <p className="info-note">Datos del responsable de la agenda en la parroquia.</p>
                    <div className="info-simple">
                      <p><strong>Esta agenda diocesana pertenece a:</strong> _______________________________</p>
                      <p><strong>No. de identificación:</strong> _______________________________</p>
                      <p><strong>Celular:</strong> _______________________________</p>
                      <p><strong>WhatsApp:</strong> _______________________________</p>
                      <p><strong>E-mail:</strong> _______________________________</p>
                      <p><strong>Facebook:</strong> _______________________________</p>
                      <p><strong>Firma:</strong> _______________________________</p>
                    </div>
                  </div>
                </div>
              )}
            </section>

            {/* Información General */}
            <div className="info-cards">
              <div className="info-card">
                <FaCalendarAlt className="card-icon" />
                <h3>Primer Paso</h3>
                <p>"ENCUENTRO CON JESÚS"</p>
              </div>
              <div className="info-card">
                <FaLightbulb className="card-icon" />
                <h3>Acento</h3>
                <p>"PRIMER ANUNCIO Y KERIGMA"</p>
              </div>
              <div className="info-card">
                <FaCross className="card-icon" />
                <h3>Año</h3>
                <p>2026</p>
              </div>
            </div>

            {/* Objetivo Diocesano */}
            <section className="agenda-section objetivo-section">
              <div className="section-header" onClick={() => toggleSection('objetivo')}>
                <h2><FaCheckCircle /> Objetivo Diocesano 2026</h2>
                {expandedSections.objetivo ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {expandedSections.objetivo && (
                <div className="section-content">
                  <p className="objetivo-text">
                    Al finalizar el año 2026, el Pueblo de Dios que peregrina en la Diócesis Ipiales en 
                    <strong> Proceso Evangelizador de "Comunión Participación y Misión"</strong>, 
                    caminando sinodalmente su fe, ha avanzado en vivir el Encuentro con Jesús, mediante:
                  </p>
                  <ul className="objetivo-list">
                    <li><FaCross /> La Liturgia</li>
                    <li><FaCross /> El Sacramento de la Confirmación</li>
                    <li><FaBook /> Catequesis Kerigmática 1</li>
                    <li><FaUsers /> El Retiro Kerigmático</li>
                    <li><FaHandshake /> La Evangelización en la política</li>
                  </ul>
                  <p className="objetivo-finalidad">
                    Para la transformación de la realidad social y eclesial.
                  </p>
                </div>
              )}
            </section>

            {/* XXIX Consejo Diocesano */}
            <section className="agenda-section consejo-section">
              <div className="section-header" onClick={() => toggleSection('consejo')}>
                <h2><FaUsers /> XXIX Consejo Diocesano de Pastoral</h2>
                {expandedSections.consejo ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {expandedSections.consejo && (
                <div className="section-content">
                  <div className="consejo-info">
                    <p><strong>Fecha:</strong> 21, 22, 23 y 24 de octubre</p>
                    <p><strong>Lugar:</strong> Casa Pastoral de San Juan</p>
                  </div>
                  
                  <div className="consejo-integrantes">
                    <h4>Integrantes del Consejo:</h4>
                    <ul>
                      <li><strong>Mons. José Saúl Grisales Grisales</strong>, Obispo de Ipiales</li>
                      <li><strong>P. Anselmo Argotty</strong>, Vicario General</li>
                      <li><strong>P. Leandro Caicedo</strong>, Vicario para la Pastoral</li>
                      <li><strong>P. Vicente Legarda</strong>, Ecónomo Diocesano</li>
                      <li><strong>P. Diego Richar Bastidas</strong>, Canciller</li>
                      <li><strong>Vicarios Foráneos:</strong> P. Hugo Cadena, P. Juan Carlos Santacruz, P. Paulo Verdugo y P. Pablo Yamá</li>
                      <li>Coordinadores de las Comisiones Diocesanas</li>
                      <li>Laicos de las diferentes estructuras pastorales</li>
                      <li>Representantes de algunas Comunidades Religiosas</li>
                    </ul>
                  </div>

                  <div className="consejo-dias">
                    <div className="dia-item">
                      <h3>Martes, 21 de octubre - 09:30 a.m.</h3>
                      <ul>
                        <li><strong>P. Leandro Caicedo:</strong> Lectura del objetivo y agenda de trabajo</li>
                        <li>Ubicación en el Proceso Diocesano de Pastoral</li>
                        <li>Presentación del informe de las Asambleas Parroquiales (información cualitativa y cuantitativa)</li>
                        <li><strong>Srta. Ángela Rosero:</strong> Dinámica de presentación</li>
                        <li><strong>Mons. José Saúl Grisales:</strong> Apertura del Consejo con elementos clave del discernimiento sinodal</li>
                        <li><strong>P. Leandro Caicedo, P. José Gómez, P. James Guadir y P. Francisco Urbano:</strong> Socialización de síntesis de logros, dificultades y desafíos de cada Centro Pastoral</li>
                        <li><strong>P. Diego Richar Bastidas:</strong> Eucaristía</li>
                        <li><strong>Jornada de la tarde:</strong> Aportes del Consejo a los Centros de Pastoral</li>
                      </ul>
                      
                      <div className="centros-pastorales">
                        <h4>Aportes por Centros de Pastoral:</h4>
                        
                        <div className="centro-item">
                          <h5>Primer Centro Pastoral</h5>
                          <p><strong>Logros:</strong></p>
                          <ul>
                            <li>Disponibilidad de escucha en espíritu de sinodalidad</li>
                            <li>Valoración de la información cuantitativa y cualitativa</li>
                            <li>Incremento de catequistas, entre ellos jóvenes</li>
                            <li>Elaboración de material de catequesis para dos diócesis</li>
                            <li>Mayor valoración de los materiales de Animación Bíblica</li>
                            <li>Valoración del curso en la Revista Palabra de Vida</li>
                          </ul>
                          <p><strong>Sugerencias:</strong></p>
                          <ul>
                            <li>Motivar integración de niños, jóvenes y padres de familia a estructuras pastorales</li>
                            <li>Fomentar mayor compromiso en formación personal</li>
                            <li>Implementar estrategias creativas para la lectio divina</li>
                            <li>Vincular jóvenes catequizandos y padres a estructuras parroquiales</li>
                          </ul>
                        </div>

                        <div className="centro-item">
                          <h5>Segundo Centro Pastoral</h5>
                          <p><strong>Logros:</strong></p>
                          <ul>
                            <li>Vinculación de laicos al Centro Pastoral</li>
                          </ul>
                        </div>

                        <div className="centro-item">
                          <h5>Tercer Centro Pastoral</h5>
                          <p><strong>Logros:</strong></p>
                          <ul>
                            <li>En los Grupos de Familia se valora la Lectio Divina y se vive la Palabra de Dios</li>
                            <li>Los jóvenes de catequesis de adultos han asumido responsablemente la Lectio Divina</li>
                            <li>Valoración de los encuentros ENCORES</li>
                          </ul>
                          <p><strong>Sugerencias:</strong></p>
                          <ul>
                            <li>Búsqueda de más líderes para coordinar ECS y Grupos de Familia</li>
                            <li>Mayor compromiso de párrocos en entrega de evaluaciones</li>
                            <li>Tener presente la Meta del quinquenio en programaciones</li>
                            <li>Realización de catequesis kerigmáticas de acompañamiento a retristas</li>
                            <li>Mayor compromiso de Movimientos Apostólicos con el Proceso Diocesano</li>
                            <li>Priorizar al clero diocesano en actividades de movimientos</li>
                            <li>Mayor motivación del cuidado de la creación en parroquias con resguardos indígenas</li>
                            <li>Realizar actividades diferentes a las propuestas en cartilla para motivar niños y jóvenes</li>
                            <li>Definir perfil del laico para integrar Comisiones Diocesanas</li>
                          </ul>
                        </div>

                        <div className="centro-item">
                          <h5>Cuarto Centro Pastoral</h5>
                          <p><strong>Logros:</strong></p>
                          <ul>
                            <li>Valoración del accionar de la Pastoral Social</li>
                            <li>Fortalecimiento del servicio vicarial</li>
                          </ul>
                          <p><strong>Sugerencias:</strong></p>
                          <ul>
                            <li>Mayor formación sobre el ser y que hacer de los Comités Parroquiales de Pastoral Social</li>
                            <li>Aprovechar Medios de Comunicación, TICS's y redes sociales para la Evangelización</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    
                    <div className="dia-item">
                      <h3>Miércoles, 22 de octubre</h3>
                      <ul>
                        <li><strong>P. Jorge Martínez:</strong> Iluminación del camino a seguir en 2026 mediante Lectio Divina (Éxodo 19, 3-8a. 16-20b)</li>
                        <li><strong>Mons. José Saúl Grisales:</strong> Presentación de la insistencia del año 2026:
                          <ul>
                            <li>La Liturgia</li>
                            <li>El Sacramento de la Confirmación</li>
                          </ul>
                        </li>
                        <li><strong>Taller con Vicarias Foráneas:</strong> Monseñor pidió a los Vicarios Foráneos desarrollar un taller con sus Vicarias. Las respuestas fueron entregadas al P. Jorge Martínez</li>
                      </ul>
                      <p><strong>04:30 p.m.</strong> - Se dio por terminada la jornada</p>
                    </div>
                    
                    <div className="dia-item">
                      <h3>Jueves, 23 de octubre - 09:20 a.m.</h3>
                      <ul>
                        <li><strong>Hna. Karina Narváez:</strong> Oración vocacional</li>
                        <li><strong>P. Leandro Caicedo:</strong> Saludo y manifestación de alegría por el nombramiento Episcopal del P. Franklin Betancourt como Obispo electo para la Diócesis de Tumaco</li>
                        <li><strong>Elaboración del Objetivo Diocesano 2026:</strong> P. Anselmo Argotty, P. Paulo Verdugo, P. Hugo Cadena, P. James Guadir, P. Venancio Figueroa, Sra. Socorro Revelo y Srta. Erika Ortiz</li>
                        <li><strong>P. Bolívar Zambrano:</strong> Socialización de la implementación de la tercera etapa de la Sinodalidad</li>
                        <li><strong>Aprobación del Objetivo Diocesano 2026</strong> (ver sección Objetivo Diocesano)</li>
                        <li><strong>Aprobación del lema:</strong> "Si nuestra fe confirmamos, en la liturgia con Jesús nos encontramos"</li>
                        <li><strong>Programación por Centros y Comisiones Diocesanas:</strong> Diligenciada en el calendario DRIVE</li>
                        <li><strong>Presencia de Monseñor Franklin Betancourt:</strong> Los participantes manifestaron su alegría. Monseñor Franklin expresó su agradecimiento</li>
                      </ul>
                      <p><strong>04:30 p.m.</strong> - Se dio por terminada la jornada</p>
                    </div>
                    
                    <div className="dia-item">
                      <h3>Viernes, 24 de octubre - 08:30 a.m.</h3>
                      <ul>
                        <li><strong>Diego Coral:</strong> Invitación a la oración</li>
                        <li><strong>P. Leandro Caicedo y P. Eduar Chingal:</strong> Proyección de la agenda diligenciada en Drive</li>
                        <li>Revisión y corrección de programaciones de Comisiones Diocesanas</li>
                        <li><strong>Socialización de programaciones:</strong> Cada coordinador de Comisiones Diocesanas socializó sus programaciones</li>
                        <li><strong>Notas de Monseñor Saúl:</strong>
                          <ul>
                            <li>Protocolos de la cultura del cuidado (seguir indicación de la Conferencia Episcopal)</li>
                            <li>Fechas de visitas pastorales (ver sección Visitas Pastorales)</li>
                            <li>Visita del Señor Nuncio Apostólico (pendiente, propuesta: mayo y/o septiembre 2026)</li>
                            <li>Comisiones Diocesanas: solicitud de propuesta de 3 integrantes (sacerdotes y laicos) para cada Comisión</li>
                            <li>Padres de familia de niños preparándose para Comunión y Confirmación deben realizar catequesis kerigmática y retiro kerigmático</li>
                          </ul>
                        </li>
                        <li><strong>P. Víctor Escobar:</strong> Presentación de la Acción Significativa (ver sección Acción Significativa)</li>
                        <li><strong>Mons. José Saúl Grisales:</strong> Palabras de clausura</li>
                        <li><strong>Evaluación:</strong> Diligenciamiento de formulario</li>
                      </ul>
                      <p><strong>01:40 p.m.</strong> - Se dio por terminado el XXIX Consejo Diocesano de Pastoral</p>
                    </div>
                  </div>
                </div>
              )}
            </section>

            {/* Acción Significativa */}
            <section className="agenda-section accion-section">
              <div className="section-header" onClick={() => toggleSection('accion')}>
                <h2><FaLightbulb /> Acción Significativa 2026</h2>
                {expandedSections.accion ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {expandedSections.accion && (
                <div className="section-content">
                  <h3 className="accion-tema">Tema: La Evangelización de la política</h3>
                  
                  <div className="accion-actividades">
                    <div className="actividad-item">
                      <h4><FaBook /> Formación Política</h4>
                      <p>Dentro de los temas de formación mensual de estructuras y de catequesis, incluir el tema de formación política.</p>
                      <p className="responsable"><strong>Responsable:</strong> P. Jorge Martínez</p>
                    </div>
                    
                    <div className="actividad-item">
                      <h4><FaUsers /> Ejercicio Lúdico Democrático</h4>
                      <p>Dentro de la programación de Pastoral Infantil y Juvenil, realizar un ejercicio lúdico democrático con niños y jóvenes, al igual que con los catequizandos de Comunión y Confirmación.</p>
                      <p className="responsable"><strong>Responsable:</strong> P. Paulo (elaboración de guion teatral)</p>
                    </div>
                    
                    <div className="actividad-item">
                      <h4><FaHandshake /> Foro con Representantes a la Cámara</h4>
                      <p>El P. Víctor Escobar, coordinador diocesano de Pastoral de Multitudes y el P. Francisco Urbano, subdirector de Pastoral Social, deberán definir la viabilidad de la realización del foro con Representantes a la Cámara.</p>
                      <p>En caso de realizarse, estará bajo la coordinación de las Pastorales Sociales Diocesanas del Sur.</p>
                      <p className="responsable"><strong>Responsables:</strong> P. Víctor Escobar y P. Francisco Urbano (gestiones)</p>
                      <p className="responsable"><strong>Sugerencia del Consejo:</strong> Realizarlo con las 3 diócesis hermanas del Sur (Ipiales, Tumaco e Ipiales) y las Pastorales Sociales de cada jurisdicción</p>
                    </div>
                    
                    <div className="actividad-item">
                      <h4><FaFileAlt /> Edición de Videos</h4>
                      <p>Edición de videos acerca de la política desde la Pastoral de Multitudes.</p>
                      <p className="responsable"><strong>Apoyo:</strong> Hna. Karina Narváez</p>
                    </div>
                  </div>
                  
                  <div className="accion-apreciaciones">
                    <h4>Apreciaciones del Consejo Diocesano:</h4>
                    <ul>
                      <li>Llegar a la base con la acción significativa</li>
                      <li>Elaboración y entrega de un guion teatral a cargo del Padre Paulo, para el ejercicio democrático con niños y jóvenes y también de la propuesta de política de Pastoral Social</li>
                      <li>En caso de que se realice el foro, tener cuidado que la Iglesia no sea utilizada para los fines particulares de cada candidato</li>
                      <li>Se sugiere que se realice con las 3 diócesis hermanas del Sur (Ipiales, Tumaco e Ipiales) y las Pastorales Sociales de cada jurisdicción</li>
                      <li>Profundizar en la Doctrina Social de la Iglesia</li>
                    </ul>
                  </div>
                </div>
              )}
            </section>

            {/* Visitas Pastorales */}
            <section className="agenda-section visitas-section">
              <div className="section-header" onClick={() => toggleSection('visitas')}>
                <h2><FaCalendarAlt /> Visitas Pastorales Programadas</h2>
                {expandedSections.visitas ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {expandedSections.visitas && (
                <div className="section-content">
                  <p>Mons. José Saúl Grisales Grisales informó las siguientes visitas pastorales:</p>
                  <div className="visitas-grid">
                    <div className="visita-item">Tábiles</div>
                    <div className="visita-item">Puerres</div>
                    <div className="visita-item">Monopamba y Alisales</div>
                    <div className="visita-item">Iles</div>
                    <div className="visita-item">Pedregal</div>
                    <div className="visita-item">Cumbitara</div>
                    <div className="visita-item">Zonas Pastorales de Sidón y Pizanda</div>
                    <div className="visita-item">Parroquias de Ricaurte y Centenario</div>
                  </div>
                  
                  <div className="visita-nuncio">
                    <h4>Visita del Señor Nuncio Apostólico</h4>
                    <p><strong>Estado:</strong> Pendiente</p>
                    <p><strong>Propuesta:</strong> Mes de mayo y/o septiembre del año 2026</p>
                  </div>
                </div>
              )}
            </section>

            {/* Notas Importantes */}
            <section className="agenda-section notas-section">
              <div className="section-header" onClick={() => toggleSection('notas')}>
                <h2><FaFileAlt /> Notas Importantes</h2>
                {expandedSections.notas ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {expandedSections.notas && (
                <div className="section-content">
                  <ul className="notas-list">
                    <li>
                      <strong>Protocolos de la Cultura del Cuidado:</strong> Se debe seguir la indicación de la Conferencia Episcopal con respecto a los protocolos de la cultura del cuidado.
                    </li>
                    <li>
                      <strong>Comisiones Diocesanas:</strong> Monseñor sugirió la presentación de propuesta de 3 integrantes (tanto sacerdotes como laicos) para cada Comisión.
                    </li>
                    <li>
                      <strong>Catequesis Kerigmática para Padres:</strong> Los padres de familia de los niños que se están preparando para los Sacramentos de la Comunión y Confirmación deben realizar la catequesis kerigmática y el retiro kerigmático.
                    </li>
                    <li>
                      <strong>Programación:</strong> La programación de actividades se realiza en el calendario DRIVE y debe ser revisada periódicamente por cada Comisión Diocesana.
                    </li>
                  </ul>
                </div>
              )}
            </section>

            {/* Firma */}
            <div className="agenda-firma">
              <p className="firma-nombre">+ José Saúl Grisales Grisales</p>
              <p className="firma-cargo">Obispo de Ipiales</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AgendaPastoral;
